// SELECTORS
export const getExperimentVariant = (experiments, name) => (
  experiments.find(item => item.id === name).variant
);

export default (state = []) => state;
